import { Alert } from '@material-ui/lab';
import { LinearProgress } from '@material-ui/core';

import useAdjustmentSheet from './adjustment/use.adjustment.sheet';
import AdjustmentSheetBody from './adjustment/adjustment.sheet.body.component';

const PROGRESS_TRACK_CLASS = 'h-0.5 mb-4';

const FIRST_LOAD_CLASS = 'min-h-[220px]';

export default function RequestFinancialAdjustmentSheet({ isOpen, priceInfo = {}, onClose, onApplied, setAlert, role }) {

    const sheet = useAdjustmentSheet({ isOpen, priceInfo, onClose, onApplied, setAlert, role });

    if (!isOpen) return null;

    const isFirstLoad = sheet.isLoading && !sheet.catalog.length;

    return (
        <section>
            <p className="mt-0 mb-4 text-sm text-gray-500">
                Marque o que aconteceu neste serviço.
            </p>

            <div className={PROGRESS_TRACK_CLASS}>{sheet.isLoading && <LinearProgress />}</div>

            {sheet.error && <Alert severity="error" className="mb-4">{sheet.error}</Alert>}

            <div
                aria-busy={sheet.isLoading}
                className={[isFirstLoad ? FIRST_LOAD_CLASS : '', sheet.isLoading ? 'pointer-events-none' : ''].filter(Boolean).join(' ')}
            >
                <AdjustmentSheetBody sheet={sheet} />
            </div>
        </section>
    );
}
